module.exports = __webpack_public_path__ + "static/media/medalExplore.0df7dd0f.png";